import { render, staticRenderFns } from "./ShareButton.vue?vue&type=template&id=8c644634&scoped=true&"
import script from "./ShareButton.vue?vue&type=script&lang=js&"
export * from "./ShareButton.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ShareButton.vue?vue&type=style&index=0&id=8c644634&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "8c644634",
  "e1bc4e56"
  
)

/* custom blocks */
import block0 from "./ShareButton.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(component)

export default component.exports